// extracted by mini-css-extract-plugin
module.exports = {"personalSettings":"UserSettingsPersonalData__personalSettings"};